import App from '@/models/App'

export default class TrafficShip extends App {
    static get entity() {
        return 'TrafficShips'
    }
    static fetchMyShips() {
        return this.query().orderBy('createdAt', 'desc').get()
    }
    static fields() {
        return {
            id: this.attr(''),
            trafficAccountId: this.attr(''),
            uuidOfAis: this.attr(''),
            name: this.attr(''),
            nameAis: this.attr(''),
            mmsi: this.attr(''),
            imo: this.attr(''),
            eni: this.attr(''),
            countryIso: this.attr(''),
            countryName: this.attr(''),
            callsign: this.attr(''),
            type: this.attr(''),
            typeSpecific: this.attr(''),
            grossTonnage: this.attr(0),
            deadweight: this.attr(''),
            teu: this.attr(''),
            liquidGas: this.attr(''),
            length: this.attr(0),
            breadth: this.attr(0),
            draughtAvg: this.attr(0),
            draughtMax: this.attr(0),
            speedAvg: this.attr(0),
            speedMax: this.attr(0),
            yearBuilt: this.attr(0),
            isNavaid: this.attr(0),
            homePort: this.attr(''),
            liveTracking: this.attr({}), // this.hasOne(TrafficShipLiveTracking, 'traffic_ship_id', 'id'),
            liveTrackingsOfCurrentVoyage: this.attr([]),
            sharedUsers: this.attr([]),
        }
    }
    static apiConfig = {
        actions: {
            fetch(params) {
                return this.get(`traffic/ships`, {
                    params: App.get(params),
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
            create(params) {
                return this.post(`/traffic/ships`, App.post(params), {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    baseURL: App.apiURL(),
                })
            },
            destroy(trafficShipId) {
                return this.delete(`traffic/ships/${trafficShipId}`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    delete: trafficShipId,
                    baseURL: App.apiURL(),
                })
            },
            share(trafficShipId, params) {
                return this.post(
                    `traffic/ships/${trafficShipId}/share`,
                    App.post(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            unshare(trafficShipId, params) {
                return this.delete(`traffic/ships/${trafficShipId}/share`, {
                    params: params,
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    baseURL: App.apiURL(),
                })
            },
        },
    }
}
